export default __webpack_public_path__ + "asset/img/share-black~ebd88671.png";